import {DateTimePicker} from "@mui/x-date-pickers";
import React from "react";
import dayjs from "dayjs";

type DateFilterProps = {
    value: string | null,
    onChange: (val: string | null) => void
    label: string
}
export default ({onChange, value, label}: DateFilterProps) => {

    return (
        <DateTimePicker
            sx={{ minWidth: "180px", width: "180px"}}
            format={"DD.MM.YY HH:mm"}
            label={label}
            ampm={false}
            slotProps={{
                actionBar: {
                    actions: ['clear',  'today','accept',],
                },
                textField: { fullWidth: true }
            }}
            value={dayjs(value)}
            onChange={(newValue) => {
                onChange(newValue?.format() || null)
            }}
        />
    );
}
